// extracted by mini-css-extract-plugin
module.exports = {"chartContainer":"styles_chartContainer__3Aim_","title":"styles_title__1aAMX"};